// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toggleSwitch/ToggleSwitch.scss
// module id = 2581
// module chunks = 0